import { Target, ComponentType } from 'data-types-config';
import type { EmailDestinationProps } from './EmailDestination.types';

export const emailDestinationDefaults: Partial<EmailDestinationProps> = {
  target: Target.Blank,
  componentType: ComponentType.Email,
  isDisabled: false,
  isVisible: true,
  text: '',
  subject: '',
};
